// eslint-disable-next-line import/prefer-default-export
export enum LOAD_DASHBOARD {
	START= 'LOAD_DASHBOARD_START',
	DONE= 'LOAD_DASHBOARD_DONE',
	FAILED= 'LOAD_DASHBOARD_FAILED'
}
